import React from 'react'
import style from './startsoon.module.css'

function Englishbyanish() {
  return (
    <div  className = {style.start_soon}>
        <img src='https://edge.uacdn.net/static/thumbnail/course/f4fd28650a4e48d088f2494cc62746cf.png?q=100&w=512' alt='_Sumit_img'/>
        <div>
          <p>HINDI    UPSC NDA</p>
          <h4>Course on Series of English MCQs</h4> 
          <p>Starts on Mar 2, 2022 • 25 lessons</p> 
          <p>Anish</p>  
        </div>
    </div>        
  )
}
export default Englishbyanish;